import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import { Button } from 'reactstrap';
import { getMember, addProject } from '../../../redux/MainAction';
import { toast } from 'react-toastify';
import Select from 'react-select';

const AddProjectModel = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const tmlist = useSelector((state) => state.Webtracker.member);
  const [empDataValue, setEmpDataValue] = useState([]);

  const [switch2, setSwitch2] = useState(true);

  const handleSwitchChange1 = () => {
    setSwitch2(!switch2);
  };

  // useEffect(() => {
  //   getList();
  // }, []);

  // const getList = () => {
  //   var data = {
  //     offset: 0,
  //     limit: 10,
  //   };
  //   dispatch(getMember(data));
  // };

  const [saveData, setSaveData] = useState({
    // "mediaId": "5f01c00b-2f73-48da-b055-3216fe291d0d", // optional
    name: '', // required
    isBillable: true, // required
    startDate: '', // optional
    endDate: '', // optional
    timeEstimate: '', // optional
    budgetEstimate: '', // optional
    projectNotes: '', // optional
    weeklyLimitPerMember: '', // optional
    hourlyRate: '', // optional
    memberID: '', // optional
    screenshotMode: '', // optional, values can be 'SCREENSHOT', 'NO-SCREENSHOT', 'BACKGROUND', 'BLURRED-SCREENSHOT'
    employeeIds: [],
    teamIds: [],
  });

  const onHandleChange = (e) => {
    const { name, value } = e.target;
    setSaveData({ ...saveData, [name]: value });
  };

  const onSaveHandle = (e) => {
    e.preventDefault();

    if (saveData?.name === '') {
      toast.error('Please add project name!', {
        position: 'top-right',
      });
      return false;
    }
    const payload = {
      name: saveData?.name,
      isBillable: switch2,
    };

    const ids = empDataValue?.map((itm) => itm?.value);

    if (saveData?.screenshotMode !== '') {
      payload.screenshotMode = saveData?.screenshotMode;
    }
    if (saveData?.hourlyRate !== '') {
      payload.hourlyRate = saveData?.hourlyRate;
    }
    if (saveData?.weeklyLimitPerMember !== '') {
      payload.weeklyLimitPerMember = saveData?.weeklyLimitPerMember;
    }
    if (saveData?.projectNotes !== '') {
      payload.projectNotes = saveData?.projectNotes;
    }
    if (saveData?.budgetEstimate !== '') {
      payload.budgetEstimate = saveData?.budgetEstimate;
    }
    if (saveData?.timeEstimate !== '') {
      payload.timeEstimate = saveData?.timeEstimate;
    }
    if (saveData?.startDate !== '') {
      payload.startDate = saveData?.startDate;
    }
    if (saveData?.endDate !== '') {
      payload.endDate = saveData?.endDate;
    }
    if (ids.length > 0) {
      payload.employeeIds = ids;
    }

    dispatch(addProject(payload));

    onClose();

    setSaveData({
      name: '', // required
      isBillable: true, // required
      startDate: '', // optional
      endDate: '', // optional
      timeEstimate: '', // optional
      budgetEstimate: '', // optional
      projectNotes: '', // optional
      weeklyLimitPerMember: '', // optional
      hourlyRate: '', // optional
      screenshotMode: '', // optional, values can be 'SCREENSHOT', 'NO-SCREENSHOT', 'BACKGROUND', 'BLURRED-SCREENSHOT'
      employeeIds: [],
      teamIds: [],
    });
  };

  const onEmployeeChange = (value) => {
    if (value) {
      setEmpDataValue(value);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal' }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h5>New Project</h5>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>

      <ul className=" nav nav-tabs nav-tabs-custom " role="tablist">
        <li className="nav-item ">
          <a
            className="nav-link active"
            data-toggle="tab"
            href="#project1"
            role="tab"
          >
            <span className="d-none d-md-block ">Project</span>
            <span className="d-block d-md-none">
              <i className="mdi mdi-home-variant h5"></i>
            </span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-toggle="tab" href="#members2" role="tab">
            <span className="d-none d-md-block">Members</span>
            <span className="d-block d-md-none">
              <i className="mdi mdi-account h5"></i>
            </span>
          </a>
        </li>
        <li className="nav-item">
          <a
            className="nav-link"
            data-toggle="tab"
            href="#properties3"
            role="tab"
          >
            <span className="d-none d-md-block">Properties</span>
            <span className="d-block d-md-none">
              <i className="mdi mdi-email h5"></i>
            </span>
          </a>
        </li>
      </ul>

      <div className="tab-content">
        <div className="tab-pane active p-3" id="project1" role="tabpanel">
          <div className="form-group">
            <label className="text-muted" for="name">
              Project Name <span className="text-danger">*</span>
            </label>
            <div
              className="d-flex justify-content-start align-items-center"
              style={{ gap: '5px' }}
            >
              <i className="mdi mdi-buffer col-sm-1 border rounded pr_icon"></i>
              <input
                type="text"
                name="name"
                className="form-control"
                id="name"
                placeholder="Enter name"
                value={saveData?.name}
                onChange={onHandleChange}
              />
            </div>
          </div>
          <div className="d-flex justify-content-start">
            <div className="">
              <input
                type="checkbox"
                id="switch_6"
                switch="purple"
                checked={switch2}
                onChange={handleSwitchChange1}
              />
              <label
                htmlFor="switch_6"
                data-on-label=""
                data-off-label=""
              ></label>
            </div>
            <span
              className="ml-3 font-16 "
              style={{ cursor: 'pointer' }}
              onClick={handleSwitchChange1}
            >
              Billable
            </span>
          </div>
          <div
            className="d-flex justify-content-between"
            style={{ gap: '5px' }}
          >
            <div className="form-group ">
              <label for="username1" className="font-14 text-muted ">
                Start
              </label>
              <input
                type="date"
                className="form-control"
                id="username1"
                name="startDate"
                value={saveData?.startDate}
                onChange={onHandleChange}
                style={{ width: '140px' }}
              />
            </div>
            <div className="form-group  ">
              <label for="username2" className="font-14 text-muted ">
                End
              </label>
              <input
                type="date"
                className="form-control"
                id="username2"
                name="endDate"
                value={saveData?.endDate}
                onChange={onHandleChange}
                style={{ width: '140px' }}
              />
            </div>
            <div className="form-group ">
              <label for="username " className="font-14 text-muted ">
                Time estimate
              </label>
              <input
                type="number"
                className="form-control"
                id="username"
                name="timeEstimate"
                value={saveData?.timeEstimate}
                onChange={onHandleChange}
              />
            </div>
            <div className="form-group">
              <label for="username3 " className="font-14 text-muted">
                Budget estimate
              </label>
              <input
                type="number"
                className="form-control"
                id="username3"
                name="budgetEstimate"
                value={saveData?.budgetEstimate}
                onChange={onHandleChange}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Notes</label>
            <textarea
              type="text"
              className="form-control"
              rows={4}
              name="projectNotes"
              value={saveData?.projectNotes}
              onChange={onHandleChange}
            />
          </div>
        </div>
        <div className="tab-pane p-3" id="members2" role="tabpanel">
          <div>
            <div className="form-group">
              <label className="control-label">Select Members</label>
              <div className="">
                <Select
                  value={empDataValue}
                  onChange={onEmployeeChange}
                  options={tmlist?.rows?.map((user) => {
                    return {
                      label: `${user?.firstName} ${user?.lastName}`,
                      value: user?.id,
                    };
                  })}
                  isMulti={true}
                />
              </div>
            </div>
            {/* <div className="form-group">
                            <label className='text-muted'>Project manager</label>
                            <div className="">
                                <select className="form-control">
                                    <option >Select Managers</option>
                                    <option value="true">True</option>
                                    <option value="false">False</option>
                               </select>
                           </div>
                        </div>
                        <div className="form-group">
                            <label className='text-muted'>Project viewer</label>
                            <div className="">
                                <select className="form-control">
                                    <option >Select viewers</option>
                                    <option value="true">True</option>
                                    <option value="false">False</option>
                               </select>
                           </div>
                        </div> */}
          </div>
        </div>
        <div className="tab-pane p-3" id="properties3" role="tabpanel">
          <div>
            <div className="d-flex justify-content-between">
              <div className="form-group">
                <label for="limit " className="font-14 text-muted">
                  Weekly limit per member
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="limit"
                  name="weeklyLimitPerMember"
                  value={saveData?.weeklyLimitPerMember}
                  onChange={onHandleChange}
                />
              </div>
              <div className="form-group">
                <label for="rate" className="font-14 text-muted">
                  Hourly rate
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="rate"
                  name="hourlyRate"
                  value={saveData?.hourlyRate}
                  onChange={onHandleChange}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="text-muted">Screenshot Mode</label>
              <div className="">
                <select
                  className="form-control"
                  name="screenshotMode"
                  value={saveData?.screenshotMode}
                  onChange={onHandleChange}
                >
                  <option value="">Select Screenshot type</option>
                  <option value="SCREENSHOT">Screenshot</option>
                  <option value="NO-SCREENSHOT">No Screenshot</option>
                  <option value="BACKGROUND">Background</option>
                  <option value="BLURRED-SCREENSHOT">Blurred Screenshot</option>
                </select>
              </div>
              <div className="border bg-light p-2 mt-3 text-center rounded">
                <span className="text-muted">
                  <i className="mdi mdi-information-outline font-18 mt-1"></i>{' '}
                  These properties apply to members in the scope of this project
                  only.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-light" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="btn btn-purple" onClick={onSaveHandle}>
          Create Project
        </button>
      </div>
    </Modal>
  );
};

export default AddProjectModel;
